import { render, staticRenderFns } from "./zoneEntrance.vue?vue&type=template&id=5ed8dc98&scoped=true"
import script from "./zoneEntrance.vue?vue&type=script&lang=js"
export * from "./zoneEntrance.vue?vue&type=script&lang=js"
import style0 from "./zoneEntrance.vue?vue&type=style&index=0&id=5ed8dc98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed8dc98",
  null
  
)

export default component.exports